<template>
    <div>
      <!-- <div class="d-flex mg-b-10 levels-outer justify-content-center">
          <div @click="fetchLevels(t)" v-for="(t) in $store.state.buddy.templates" 
          :class="`${t.active?'active':''} mg-r-10 bg-white pd-x-10 pd-y-5 tx-semibold min-w-1 text-center`"
          style="min-width: 100px">
            {{ t.name }}
          </div>
        </div> -->

       
<!-- <div class="mg-b-10 tx-semibold d-flex justify-content-center">
  <div class="inline-flex rounded-sm bd border-gray-100 bg-white p-1">
  <button @click="fetchLevels(t)" v-for="(t) in $store.state.buddy.templates"
    :class="`inline-block ${t.active?'bg-gray-100 tx-gray-700':'tx-gray-500'} rounded-sm px-4 py-2 text-sm  hover:tx-gray-700 focus:relative`"
  >
    {{ t.name }}
  </button>
</div>


</div> -->




      <div class="check-outer wd-100p">
          <div v-for="(m, i) in $store.state.buddy.boxSummary" :class="`tx-white mg-b-10 check-item check-code-${m.code} pd-x-40 pd-y-20`" >
            <div class="tx-semibold tx-16 text-center mg-b-10 check-title">{{ m.boxName }}</div>
            
            <vc-donut
            :sections="[
              {
                value: m.progress,
                color: 'white',
              },
            ]"
            :background="getFieldFromConstants('bgColor', m)"
            :foreground="getFieldFromConstants('borderColor', m)"
            :size="80"
            unit="%"
            :thickness="12"
            :total="100"
            :start-angle="0"
          >
            <div class="tx-semibold">
              <div class="tx-lg-28 tx-md-20 tx-sm-16 tx-xs-14 tx-white" v-html="`${m.progress.toFixed(1)}%`">
              </div>
              <div class="tx-lg-16 tx-md-14 tx-sm-12 tx-xs-8 tx-color-04">{{m.doneCheckCount}}/{{ m.allCheckCount }}</div>
            </div>
          </vc-donut>

            <div @click="$emit('on-detail', m)" role="button" style="left: 50%; transform: translate(-50%, 0%); border-radius: 30px;" class="chk-more pos-absolute b-30 bg-white-1 tx-16 tx-semibold pd-x-40 pd-y-10 text-center">Дэлгэрэнгүй</div>
            <!-- <div @click="$router.push({name: 'buddyAdminReportDetail', params: {id: m.code}})" role="button" style="left: 50%; transform: translate(-50%, 0%); border-radius: 30px;" class="chk-more pos-absolute b-30 bg-white-1 tx-16 tx-semibold pd-x-40 pd-y-10 text-center">Дэлгэрэнгүй</div> -->
          </div>
        </div>
        
    </div>
</template>
<script>
import contstants from "@/constants";
export default {
  props:{
      title: {
          type: String,
          default: () => ""
      },
  },
  data(){
    return{
      buddyLevels: contstants.levels,
    }
  },
  methods:{
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    fetchLevels(t){
      // console.log('t', t);
      let _obj=this.$store.state.buddy.boxSummaryFilter;
      _obj.departId= null;
      _obj.templateId= t.id;
      this.toggleBodyClass("addClass", "dynamic-locker");
      this.$store.dispatch('buddy/handleBoxSummary',{
        filter: _obj,
        store: this.$store
      }).then((res)=>{
        this.toggleBodyClass("removeClass", "dynamic-locker");
      });
    },
    getFieldFromConstants(field, level){
      let rv='';
      if(this.buddyLevels.filter(x=>x.code==level.code).length ){
        rv= this.buddyLevels.filter(x=>x.code==level.code)[0][field];
      }
      return rv
    },
  }
}
</script>